(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity/assets/react/components/select-charity-card.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity/assets/react/components/select-charity-card.js');

'use strict';

var _svs;
const {
  Card,
  CardHeader,
  CardExpandableBody,
  CardFooter
} = svs.ui.ReactCard;
const Button = svs.ui.ReactButton;
const cdn = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2.replace('/content', '');
const {
  postSelectCharity
} = svs.lyckoplatsen.components.shared_charity.api_calls;
const {
  useHistory
} = ReactRouterDOM;
const {
  logger
} = svs.lyckoplatsen;
const {
  trackVGHOPicked
} = svs.lyckoplatsen.shared_charity;
const SelectCharityCard = _ref => {
  let {
    charity,
    wagerId,
    onClick,
    showButtonInFooter = false
  } = _ref;
  const history = useHistory();
  const handleClick = async () => {
    if (wagerId) {
      try {
        const response = await postSelectCharity({
          clientSerial: wagerId,
          charityId: charity.charityId
        });
        if (response.status === 'success') {
          trackVGHOPicked(false, charity.name);
          logger.info("Change or added Charity on Wager, wagerId: ".concat(wagerId, " charityId: ").concat(charity.charityId));
          history.replace("/relaterat/".concat(wagerId, "/").concat(charity.charityId));
        } else {
          logger.warn('Could not add charity', response);
        }
      } catch (error) {
        logger.error('Could not add charity', error);
        return svs.tur.apierrors.showErrorMessage({
          response: error.code
        });
      }
    } else {
      svs.utils.url.navigate("/lyckoplatsen/spela?charityId=".concat(charity.charityId));
    }
  };
  const handleClickPick = onClick || handleClick;
  const selectCharityButton = () => React.createElement("div", {
    className: "select-charity-button"
  }, React.createElement(Button, {
    inverted: true,
    onClick: handleClickPick
  }, "V\xE4lj"));
  return React.createElement("div", {
    className: "lp-charity-card"
  }, React.createElement(Card, {
    expandable: true
  }, React.createElement(CardHeader, null, (charity === null || charity === void 0 ? void 0 : charity.logotypeId) && React.createElement("div", {
    style: {
      marginLeft: '16px'
    },
    className: "card-charity-header-content"
  }, React.createElement("img", {
    className: "margin-top-1 margin-bottom-1",
    src: cdn + charity.logotypeId,
    alt: "".concat(charity.name, " logo")
  }))), React.createElement(CardExpandableBody, null, (charity === null || charity === void 0 ? void 0 : charity.description) && React.createElement("p", null, charity.description), (charity === null || charity === void 0 ? void 0 : charity.externalUrl) && React.createElement("p", null, React.createElement("a", {
    href: charity.externalUrl,
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "Bes\xF6k ", charity.name), " f\xF6r mer information"), !showButtonInFooter && selectCharityButton()), React.createElement(CardFooter, {
    className: "charity-card-footer",
    align: "center"
  }, showButtonInFooter && selectCharityButton())));
};
setGlobal('svs.lyckoplatsen.components.shared_charity.react.components', {
  SelectCharityCard
});

 })(window);